export default __webpack_public_path__ + "static/media/azobe_wood_1.486014db.jpg";